import { LEAD_STATUSES } from "../../Lead/constants/lead-statuses.ts"

/**
 * Statuses `_destroy_lead` accepts in ezbuild_back. A lead on any other stage
 * is refused one at a time, so a bulk selection off the active list is almost
 * entirely ineligible — the bar says so before the request rather than
 * repeating the server's reason once per lead afterwards.
 */
const DELETE_LEAD_ALLOWED_STATUSES: number[] = [
  LEAD_STATUSES.UNQUALIFIED,
  LEAD_STATUSES.LOST,
  LEAD_STATUSES.WON
]

export { DELETE_LEAD_ALLOWED_STATUSES }
